<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Course Recommender"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('course_recommender')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Course Recommender
      Tool. The Course Recommender Tool allows you to view recommended courses
      for a selected student based on their taken courses.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Course Recommender
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Recommender Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="Course Recommender Table Result"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- Course Recommender Tool At First Glance ---------->

        <h3 class="h3-second-header">
          Course Recommender Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 25.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageCourseRecommenderFig25']"
            alt=""
          />
          <p class="picture-caption">Figure 25: Course Recommender Tool Page</p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Course Recommender Form Guide ---------->
        <h3 class="h3-second-header">Course Recommender Form Submission</h3>

        <ol class="ordered-list">
          <li>
            Select the Recommender Type (Popular [Most Course Enrollment], Easy
            [Highest Average Pass Rate], Good [Mix of Easy/Popular])
          </li>
          <li>Enter a Student ID or Name</li>
          <ul>
            <li>
              Once the student ID or name is entered and a student is selected
              from the dropdown list, the cohort, program, and college will
              automatically be populated.
            </li>
          </ul>
          <li>
            Select a Semester (Fall[1,2,3,4,...], Spring[1,2,3,4,...],
            Summer[1,2,3,4,...])
          </li>
          <li>For the taken courses box (Figure 26)</li>
          <ul>
            <li>You can also add more courses to the taken courses box</li>
            <li>
              You can add it by selecting a course number and course grade.
              After that just click the button 'add course'.
            </li>
          </ul>
          <div>
            <p></p>
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageCourseRecommenderFig26']"
              alt=""
            />
            <p class="picture-caption">Figure 26: Taken Courses History</p>
          </div>
          <li>
            You can also view the student's profile if you click on the 'View
            Student' button(Figure 26a) at the very bottom of the form.
          </li>
          <div>
            <p></p>
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageCourseRecommenderFig26a']"
              alt=""
            />
            <p class="picture-caption">Figure 26a: View Student Button</p>
          </div>
          <li>
            * Lastly, click on the ‘Submit’ button to generate results for
            course recommender tool.
          </li>
        </ol>
        <br />
      </div>

      <div class="left-align-div">
        <ul class="unordered-list">
          <li>
            Below is an example for course recommender form filled with values.
          </li>
        </ul>
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageCourseRecommenderFig26b']"
            alt=""
          />
          <p class="picture-caption">Figure 26b: Recommender Filter (1)</p>
        </div>
      </div>

      <div class="left-align-div">
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageCourseRecommenderFig26c']"
            alt=""
          />
          <p class="picture-caption">Figure 26c: Recommender Filter (2)</p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, the results will be shown as a table of
            recommended courses just like the screenshot (Figure 27) below.
          </li>
        </ul>
        <div>
          <img
            class="set-img-width-med"
            [(src)]="env['logo_paths']['helpPageCourseRecommenderFig27']"
            alt=""
          />
          <p class="picture-caption">Figure 27: Course Recommender Results</p>
        </div>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Course Recommender',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
